import { render, staticRenderFns } from "./SPRPagerHeading.vue?vue&type=template&id=79a17dfa"
import script from "./SPRPagerHeading.vue?vue&type=script&lang=ts"
export * from "./SPRPagerHeading.vue?vue&type=script&lang=ts"
import style0 from "./SPRPagerHeading.vue?vue&type=style&index=0&id=79a17dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports